const registrationTableColums = [
    {
        title: "lenderRegistrationsPage.table_column_full_name",
        dataIndex: "full_name",
        key: "full_name",
    },{
        title: "lenderRegistrationsPage.table_column_email",
        dataIndex: "email",
        key: "email",
    },{
        title: "lenderRegistrationsPage.table_column_phone_number",
        dataIndex: "phone_number",
        key: "phone_number",
    },{
        title: "lenderRegistrationsPage.table_column_submitted_on",
        dataIndex: "created_at",
        key: "created_at",
        render : (timestamp) => {
            return new Date(timestamp).toLocaleDateString()
        }
    }
]

export {
    registrationTableColums,
}